<div class=" container-fluid mt-4">
    <!-- Row -->
    <div class="card">
        <div class="card-header">
            <h5 class="font-medium  election-title">🧾 Society Verification Details</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="mb-3 ">
                        <p class="fs-14px">It will show you the data of assigned district audit officer for last 3
                            verification of the society</p>
                    </div>
                </div>

                <div class="col-lg-12" *ngIf="societyVerificationDetails.length > 0">
                    <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                        [rows]="societyVerificationDetails" [columns]="column" [columnMode]="'force'"
                        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" 
 [virtualization]="false" [scrollbarV]="false"
                        [scrollbarH]="true">

                        <!-- Serial Number Column -->
                        <ngx-datatable-column name="#" [sortable]="false">
                            <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                <span>
                                    {{ (page.pageNumber * page.pageSize) + rowIndex + 1 }}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Dynamic Data Columns -->
                        <ngx-datatable-column *ngFor="let col of column" [name]="col.name" [prop]="col.prop"
                            [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                {{ value }}
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>

    <form #verifierForm="ngForm" (ngSubmit)="assignVerifier(verifierForm)">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">

                    <div class="row ">
                        <div class="col-lg-12">
                            <div class="card-header w-100">
                                <h5 class="election-title">👨‍⚖️ Assign Verifier</h5>
                            </div>
                            <div class="card-body">
                                <div class="row ">


                                    <div class="col-lg-3 col-md-6 mb-2">
                                        <label for="designation" class="form-label">Designation</label>
                                        <select class="form-control" [(ngModel)]="ddlDesignation" id="ddlDesignation"
                                            name="ddlDesignation" (change)="onDesignationChange($event)" required>
                                            <option value="">Select Designation</option>
                                            <option *ngFor="let data of designationsData" [value]="data.id">
                                                {{ data.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-lg-3 col-md-6 mb-2">
                                        <label for="roleOfficer" class="form-label">Role Officer</label>
                                        <select class="form-control" [(ngModel)]="ddlRoleOfficer" id="ddlRoleOfficer"
                                            name="ddlRoleOfficer" (change)="onRoleOfficerChange($event)" required>
                                            <option value="">Select Role Officer</option>
                                            <option *ngFor="let data of officerData" [value]="data.id">
                                                {{ data.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-header w-100">
                        <h5 class="election-title">🧑‍💼 Audit Officer Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row ">
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Total Verification Conducted</label>
                                <p class="form-control-static">{{ totalConducted }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Total Verification Completed</label>
                                <p class="form-control-static">{{ totalCompleted }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Is Part of your last three Verification</label>
                                <p class="form-control-static">{{ lastThreeVerification === true ? 'Yes' :
                                    (lastThreeVerification === false ? 'No' : 'N/A') }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Is Part of your last three Audit</label>
                                <p class="form-control-static">{{ lastThreeAudit === true ? 'Yes' : (lastThreeAudit ===
                                    false ? 'No' : 'N/A') }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Verifier Name</label>
                                <p class="form-control-static">{{ verifierName }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Designation</label>
                                <p class="form-control-static">{{ designation }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Circle of Officer</label>
                                <p class="form-control-static">{{ circle }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Mobile No</label>
                                <p class="form-control-static">{{ mobileNo }}</p>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">Email Id</label>
                                <p class="form-control-static">{{ emailId }}</p>
                            </div>

                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="!verifierForm.valid">
                                    Assign Verifier
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>



</div>